export default function () {
  return {
    current: 'light',
  }
}
